import React from 'react';
import { CheckCircle } from 'lucide-react';
const includes = ['PACK EDITABLE DE DOCUMENTOS PROFESIONALES™', 'SISTEMA DE OPERACIÓN DIARIA™', 'KIT OPERATIVO DE MOSTRADOR™', 'Ahorrar tiempo y verte más profesional', 'Organizar mejor tu flujo diario y reducir caos', 'Manejar situaciones difíciles con claridad y seguridad'];
export function SistemaOperativoSection() {
  return <section className="bg-[#0B0B12] pt-6 pb-16 px-5 relative overflow-hidden" data-id="element-285">
      <div className="blur-circle bg-brand-blueDeep/20 top-0 left-0 opacity-30" data-id="element-286" />
      <div className="max-w-xl mx-auto relative z-10" data-id="element-287">
        <div className="text-center mb-12" data-id="element-288">
          <span className="bg-brand-gold/10 text-brand-gold text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-[0.2em] mb-6 inline-block border border-brand-gold/20" data-id="element-289">
            ⭐ EXCLUSIVO DEL PACK COMPLETO
          </span>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-290">
            🧠 ¿QUÉ AGREGA EL KIT DE IMPLEMENTACIÓN?
          </h2>
          <p className="text-base text-slate-400 font-bold max-w-md mx-auto uppercase tracking-tight" data-id="element-291">
            El MegaPack te entrega el sistema. Pero esto te ayuda a{' '}
            <span className="gold-text-gradient font-black" data-id="element-292">
              IMPLEMENTARLO más rápido
            </span>{' '}
            en tu trabajo real.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 mb-10 shadow-2xl backdrop-blur-md" data-id="element-293">
          <h3 className="text-lg font-black text-center mb-8 uppercase tracking-[0.3em] gold-text-gradient" data-id="element-294">
            💥 ESTO INCLUYE:
          </h3>
          <div className="space-y-4" data-id="element-295">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white/5 p-4 rounded-xl border border-white/10 shadow-xl transition-all hover:bg-white/10" data-id="element-296">
                <CheckCircle className="text-brand-gold flex-shrink-0" size={24} data-id="element-297" />
                <span className="text-sm md:text-base font-black text-slate-200 uppercase tracking-tight" data-id="element-298">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <div className="relative group" data-id="element-299">
          <div className="absolute -inset-1 bg-gradient-to-r from-brand-gold/40 to-brand-gold/10 rounded-3xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200" data-id="element-300"></div>
          <div className="relative border border-brand-gold/30 p-8 rounded-3xl shadow-2xl overflow-hidden bg-[#2E2E2E]" data-id="element-301">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 bg-brand-gold/10 w-24 h-24 rounded-full blur-2xl pointer-events-none" data-id="element-302"></div>

            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-303">
              <div className="bg-brand-gold text-black px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-[0.2em] whitespace-nowrap shadow-[0_0_15px_rgba(212,176,106,0.3)]" data-id="element-304">
                Diferencia Crítica
              </div>

              <div className="flex-grow space-y-4" data-id="element-305">
                <div className="flex items-start gap-3" data-id="element-306">
                  <div className="text-slate-500 font-black text-xs mt-1" data-id="element-307">
                    01
                  </div>
                  <p className="text-sm text-slate-400 font-bold uppercase tracking-tight" data-id="element-308">
                    <span className="text-white font-black mr-2" data-id="element-309">
                      Solo MegaPack:
                    </span>
                    Entendés el sistema y aprendés la teoría.
                  </p>
                </div>

                <div className="flex items-start gap-3" data-id="element-310">
                  <div className="text-brand-gold font-black text-xs mt-1" data-id="element-311">
                    02
                  </div>
                  <p className="text-sm text-slate-200 font-black uppercase tracking-tight" data-id="element-312">
                    <span className="gold-text-gradient font-black mr-2" data-id="element-313">
                      Sistema Completo:
                    </span>
                    Aprendés + tenés las herramientas listas para implementar
                    hoy mismo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}